
/**
 * src/web/components/report-status-page.jsx
 * 日報提出状況ページ（right-side-page に表示）
 */

import React from 'react'
import ReactDOM from 'react-dom'
import connect from '../../connects/report-status-page'
import {
  List,
  ListItem,
} from 'react-toolbox/lib/list'
import {
  Tab,
  Tabs
} from 'react-toolbox/lib/tabs'
import Checkbox from 'react-toolbox/lib/checkbox'
import Avatar from 'react-toolbox/lib/avatar'
import FontIcon from 'react-toolbox/lib/font_icon'
import Tooltip from 'react-toolbox/lib/tooltip'
import {
  Button,
  IconButton,
} from 'react-toolbox/lib/button'
import Loading from './loading.jsx'
import RightSidePage from './right-side-page.jsx'
import _ from 'lodash'
import moment from 'moment'
import reportStatusTheme from './themes/report-status.css'
import smallAvatar from './themes/small-avatar.css'
import {
  Table,
  Column,
  Cell
} from 'fixed-data-table-2'
import 'fixed-data-table-2/dist/fixed-data-table.css'
import UserMonthlySummaryPage from './user-monthly-summary-page'
import { GoogleLogin } from './google-signin-provider.jsx'
import {
  Card,
  CardText,
} from 'react-toolbox/lib/card'
import {
  IconMenu,
  MenuItem,
} from 'react-toolbox/lib/menu'
import DropDown from 'react-toolbox/lib/dropdown'
import {
  RadioButton,
  RadioGroup
 } from 'react-toolbox/lib/radio'
import { eventEmitter } from "../../connects/eventEmitter"

const TooltipIconButton = Tooltip(IconButton)

function ActivityIcon(props) {
  const {
    icon,
    color,
    ids,
    onClick,
  } = props

  const diary_ids = ids && ids.split(',').map((id)=> parseInt(id)) || []
  const count = diary_ids.length || 0

  if (count == 0)
    return (<div className={reportStatusTheme.activityEmptyBadge} />)
  else
    return (
      <div onClick={()=> onClick(diary_ids)} className={reportStatusTheme.activityIcon}>
        <FontIcon value={icon} className={reportStatusTheme.activityFontIcon} style={{ color }} />
        {count > 1 &&
          <span className={reportStatusTheme.activityBadge}>
            {count}
          </span>
        }
      </div>
    )
}

function WeekdayHeader(props) {
  const {
    day,
    width,
    showDetail,
    fetchActivityReportPrev,
    fetchActivityReportNext,
  } = props

  const weekdaysShort = moment.weekdaysShort()
  const weekday = day.day()
  var color = 'black'
  var arrow_left, arrow_right
  var onClick
  if (weekday == 0) {
    arrow_left = true
    color = 'red'
    onClick = fetchActivityReportPrev
  }
  if (weekday == 6) {
    arrow_right = true
    color = 'blue'
    onClick = fetchActivityReportNext
  }

  return (
    <Cell width={width}>
      <div onClick={onClick} className={color == 'black' && reportStatusTheme.headerBlack || color == 'red' && reportStatusTheme.headerRed || reportStatusTheme.headerBlue}>
        {arrow_left && <FontIcon value='keyboard_arrow_left' className={reportStatusTheme.headerFontIcon}/>}
        {day.date()} <span className={reportStatusTheme.headerBody}>{weekdaysShort[weekday]}</span>
        {arrow_right && <FontIcon value='keyboard_arrow_right' className={reportStatusTheme.headerFontIcon}/>}
      </div>
    </Cell>
  )
}

function ReportStatusCell(props) {
  const {
    activityReports,
    fetchActivityReport,
    mode,
    rowIndex,
    columnIndex,
    width,
    height,
    showDetail,
    onClick,
  } = props

  const activity = activityReports[rowIndex].activity[columnIndex]
  const {
    diary,
    memo,
    kpi,
    like,
    comment,
  } = activity

  const schedule = activityReports[rowIndex].submission_schedules.length > 0 && activityReports[rowIndex].submission_schedules[columnIndex]
  let diaryData = diary && diary.length > 0 
  let kpiData = kpi && kpi.length > 0 

  const report_data = diaryData || kpiData

  //schedule.submissionがfalseの場合、width,heightから左右のmargin:3 * 2を引いた分を渡すようにする
  const cell_width = !report_data && schedule && schedule.submission === false ? (width - 6) : width
  const cell_height = !report_data && schedule && schedule.submission === false ? (width - 6) : height

  return (
    <Cell width={cell_width} height={cell_height} style={{ backgroundColor: !report_data && schedule && schedule.submission === false && '#D3DEF1', margin: '3px' }}>
      {showDetail &&
      <div className={reportStatusTheme.cellBody}>
        <ActivityIcon icon='event_note' color='green' ids={diary} onClick={onClick} />
        <ActivityIcon icon='insert_chart' color='green' ids={kpi} onClick={onClick} />
        <ActivityIcon icon='assignment' color='green' ids={memo} onClick={onClick} />
      </div>}
      {showDetail &&
      <div className={reportStatusTheme.cellBody}>
        <ActivityIcon icon='favorite' color='red' ids={like} onClick={onClick} />
        <ActivityIcon icon='comment' color='blue' ids={comment} onClick={onClick} />
      </div>
      }
      {!showDetail && diaryData && kpiData &&
      <div className={reportStatusTheme.cellBody}>
        <ActivityIcon icon='check' color='green' ids={diary.concat(',',kpi)} onClick={onClick} />
      </div> || 
      !showDetail && diaryData && !kpiData &&
      <div className={reportStatusTheme.cellBody}>
        <ActivityIcon icon='check' color='green' ids={diary} onClick={onClick} />
      </div> || 
      !showDetail && !diaryData && kpiData &&
      <div className={reportStatusTheme.cellBody}>
        <ActivityIcon icon='check' color='green' ids={kpi} onClick={onClick} />
      </div> || null
      }
    </Cell>
  )
}

const TooltipButton = Tooltip(Button)

class ReportStatusPage extends React.Component {
  state = {
    showMenu: false,
    showDownload: false,
    sendingMethodValue: 'local',
    checkFolder: true,
  }
  constructor(props) {
    super(props);
    //下記の処理を行わないとwillUnmountで記述しているremoveEventListenerがうまくいかない
    this.changeWindowDisplay = this.changeWindowDisplay.bind(this) 
    this.debounce = _.debounce(this.changeWindowDisplay, 500)
    this.handleUpdateShowDownloadState = this.handleUpdateShowDownloadState.bind(this);
  }

  unLinkGoogleDrive = ()=> {
    this.props.cancelGoogleDrive()
    this.props.ui.gapiReady && GoogleLogin.signOut()
    this.props.updateUI({ gapiReady: false, folder_id: 'undefined' })
  }

  onGoogleSignSuccess = ()=> {
    this.props.fetchUserInfo()
    this.props.fetchFolders()
    this.props.updateUI({ gapiReady: true })
  }

  onSelectFolder = (folder_id) => {
    this.props.updateUI({ folder_id: folder_id })
    this.setState({ checkFolder: true })
  }

  onDownloadFile = () => {
    if (this.state.sendingMethodValue == 'local') {
      window.open(this.props.exportUrl(this.props))
    } else {
      // check GoogleDrive folder validation
      if (this.props.ui.folder_id == 'undefined') {
        this.setState({ checkFolder: false })
      } else {
        this.setState({ checkFolder: true })
        this.props.downloadFile(this.props)
      }
    }
  }

  sendingMethodChange = (value)=> {
    this.setState({ sendingMethodValue:  value })
  }

  handleUpdateShowDownloadState(newState) {
    // Update the state when the event is emitted
    this.setState(newState);
  }

  componentDidMount() {
    eventEmitter.on("updateShowDownloadState", this.handleUpdateShowDownloadState);
    this.props.updateUI({ innerWidth: ReactDOM.findDOMNode(this).clientWidth })
    setTimeout(() => this.props.updateUI({ innerHeight: ReactDOM.findDOMNode(this).clientHeight }), 0)
    window.addEventListener('resize', this.debounce)
  }

  componentWillUnmount() {
    eventEmitter.removeListener("updateShowDownloadState", this.handleUpdateShowDownloadState);
    window.removeEventListener('resize', this.debounce)
  }

  changeWindowDisplay = () => {
    this.props.updateUI({ innerWidth: ReactDOM.findDOMNode(this).clientWidth })
    setTimeout(() => this.props.updateUI({ innerHeight: ReactDOM.findDOMNode(this).clientHeight }), 0)
  }

  onClick = (user)=> {
    this.props.updateUI({
      active: true,
      user: user,
    })
  }

  onClose = ()=> {
    this.props.updateUI({
      active: false
    })
  }

  exportUrl = ()=> window.open(this.props.exportUrl(this.props))

  reloadActivity = () => this.props.reloadActivity(this.props)
  
  componentDidUpdate(prevProps) {
    if (!prevProps.isFoldersFetchFailed && this.props.isFoldersFetchFailed) {
      GoogleLogin.signOut()
      this.props.updateUI({ gapiReady: false })
    }
  }

  render() {
    const {
      t,
      ui,
      isFetching,
      isFetchFailed,
      activityReports,
      group,
      fetchActivityReport,
      openPickupDiaries,
      openUserTimeline,
      exportUrl,
      updateUI,
      currentUser,
      reloadActivity,
      folders,
      userinfo,
      fetchFolders,
      isFoldersFetching,
      isFoldersFetchFailed,
      fetchUserInfo,
      cancelGoogleDrive,
      isUserInfoFetching,
      isUserInfoFetchFailed,
      isUploadFetching,
      isUploadFetchFailed,
      downlaodFile,
    } = this.props

    const weekDays = activityReports && activityReports.length > 0 && _.map(activityReports[0].activity, (activity)=> moment(activity.reported_at))
    const innerWidth = Math.round(ui.innerWidth / 10) * 10 //一の位を0にするための処理
    const innerHeight = Math.round(ui.innerHeight / 10) * 10 - 115 //最後の115はappBarとCheckBoxと水平スクロールバーの高さを合計したもの
    const activityReportsHeight = activityReports && activityReports.length > 0 && (this.state.showDetail ? 80 : 38) * activityReports.length + 32
    const nameWidth = 150
    const innerMinWidth = nameWidth  + 350 //一つ辺りのcolumnWidthが40pxになるように設定
    const columnWidth = Math.round((innerWidth - nameWidth) / 7)
    const startDay = weekDays && weekDays[0]
    
    let dropDownSource = [
      { value: 'undefined', label: t('label:フォルダを選択して下さい') }
    ]

    if (folders && folders.length > 0) {
      const folderOptions = folders.map(folder => ({
        value: folder.id,
        label: folder.name
      }))
      dropDownSource = dropDownSource.concat(folderOptions)
    }

    return (
      <div>
        <RightSidePage title={t('label:日報提出状況')} icon="check_box"
          rightAction={ group.is_member &&
            <IconButton
              icon='cloud_download'
              key='icon'
              disabled={this.state.showDownload}
              onClick={()=> this.setState({ showDownload: true })}
            />
          }
        >
          {this.state.showDownload &&
          <Card style={{ marginBottom: 20, background: '#f7f7f7' }}>
            <CardText style={{ textAlign: 'right', padding: '0px 10px' }}>
              <IconButton icon='close' onClick={()=> this.setState({ showDownload: false })} />
            </CardText>
            {(isFoldersFetching || isUploadFetching || isUserInfoFetching) &&
            <Loading />
            }
            <CardText className={reportStatusTheme.sendingMethod}>
              <strong>{t('label:送信方法')}</strong>
              <RadioGroup
                className={reportStatusTheme.radioGroup}
                value={this.state.sendingMethodValue}
                onChange={this.sendingMethodChange}
              >
                <RadioButton label={t('label:ローカルに保存')} value='local'/>
                <RadioButton label='Googleドライブ' value='drive' />
              </RadioGroup>
            </CardText>
            {this.state.sendingMethodValue == 'drive' &&
            <div>
              <CardText className={reportStatusTheme.googleSignInBtn}>
                {!ui.gapiReady &&
                <GoogleLogin label={t('label:Googleドライブに接続する')} onSuccess={this.onGoogleSignSuccess} type={'google_drive'} />
                }
                {!isUserInfoFetchFailed && ui.gapiReady && userinfo &&
                <List>
                  <span className={reportStatusTheme.normalTitle}>{t('label:アカウント')}</span>
                  <ListItem
                    className={reportStatusTheme.userInfo}
                    rightActions={[
                      <IconMenu key="menu" icon="more_vert" onClick={()=> this.setState({ showMenu: true })}>
                        <MenuItem
                          icon="delete_forever"
                          onClick={this.unLinkGoogleDrive}
                          caption={t('label:Googleドライブを解除')}
                        />
                      </IconMenu>
                    ]}
                  >
                    <span>{userinfo.displayName}</span>
                    <span>({userinfo.emailAddress})</span>
                  </ListItem>
                </List>
                }
                {ui.gapiReady &&
                <List>
                  <span className={reportStatusTheme.normalTitle}>{t('label:フォルダの選択')}</span>
                  {folders && folders.length == 0 &&
                  <ListItem caption={t('label:フォルダがありません')} selectable={false} />
                  }
                  <DropDown auto
                    source={dropDownSource}
                    value={ui.folder_id}
                    onChange={this.onSelectFolder}
                  />
                  {!this.state.checkFolder &&
                  <CardText style={{ color: 'red', paddingLeft: 0, paddingTop: 0 }}>
                    <FontIcon value='error' style={{ verticalAlign: 'bottom', fontSize: 18 }}/>
                    <span style={{ marginLeft: 5 }}>{t('label:フォルダを選択して下さい1')}</span>
                  </CardText>
                  }
                </List>
                }
              </CardText>
            </div>
            }
            <CardText>
              <Button raised primary
                disabled={this.state.sendingMethodValue == 'drive' && !ui.gapiReady}
                onClick={this.onDownloadFile}
                style={{width: '100%'}}
                label={t('label:エクスポート')}
              />
            </CardText>
          </Card>
          }
          {!isFetchFailed &&
            <Checkbox checked={this.state.showDetail}
              label={t('label:詳細をすべて表示')}
              className={reportStatusTheme.checkbox}
              onChange={()=> this.setState({ showDetail: !this.state.showDetail })} />
          }
          {!isFetchFailed && !isFetching && activityReports && activityReports.length > 0 &&
            <Table
                height={innerHeight >= activityReportsHeight ? activityReportsHeight : innerHeight}
                //innerWidthがinnerMinWidthより下回った場合はinnerMinWidthを設定する なお15pxは右端のスクロールバーの横幅分である
                //innerHeightがactivityReportsHeightが上回った場合は右端のスクロールバーは必要ないため、その分の15pxはない状態にする
                width={innerWidth <= innerMinWidth ? innerMinWidth + 15 : innerHeight >= activityReportsHeight ? innerWidth : innerWidth + 15}
                overflowX='hidden'
                headerHeight={30}
                rowsCount={activityReports.length}
                rowHeight={this.state.showDetail ? 80 : 38}>
              <Column fixed
                  width={nameWidth}
                  header={<div className={reportStatusTheme.startDay}>{startDay && moment(startDay).format('ll') || ''}</div>}
                  cell={(cellProps)=> (
                    <Cell>
                      <TooltipButton
                          className={reportStatusTheme.users}
                          tooltip={t('label:月間日報提出状況を表示')}
                          onClick={()=>{ this.onClick(activityReports[cellProps.rowIndex].user)}} >
                        <Avatar image={activityReports[cellProps.rowIndex].user.icon_image.thumb_url} theme={smallAvatar}/>
                          &nbsp;{activityReports[cellProps.rowIndex].user.name}
                      </TooltipButton>
                    </Cell>
                )} />
              {_.map(weekDays, (day, i)=> (
                <Column key={i}
                      width={innerWidth <= innerMinWidth ? 50 : columnWidth} //innerWidthがinnerMinWidthより下回った場合は定数を設定する
                      header={
                        <WeekdayHeader day={day}
                            showDetail={this.state.showDetail}
                            fetchActivityReportPrev={()=> fetchActivityReport(this.props, 'prev')}
                            fetchActivityReportNext={()=> fetchActivityReport(this.props, 'next')} />}
                      cell={
                        <ReportStatusCell columnIndex={i} day={day}
                            onClick={openPickupDiaries}
                            showDetail={this.state.showDetail}
                            activityReports={activityReports} />} />
              ))}
            </Table>
          }
          {!isFetchFailed && !isFetching && (!activityReports || activityReports.length == 0) &&
            <div className={reportStatusTheme.noMember}>
              {t('label:メンバーは登録されていません')}
            </div>
          }
          {isFetchFailed &&
            <div className={reportStatusTheme.failed}>{t('label:日報提出状況の取得に失敗しました')}</div>
          }
          {ui.user &&
            <UserMonthlySummaryPage
              reportDate={ui.startDate}
              group={group}
              currentUser={currentUser}
              user={ui.user}
              onClose={this.onClose}
              open={ui.active} />
            }
        </RightSidePage>
      </div>
    )
  }
}

export const RawReportStatusPage = ReportStatusPage
export default connect(ReportStatusPage)



// WEBPACK FOOTER //
// ./src/web/components/report-status-page.jsx